const state = {
  token: '',
  isAuthenticated: false,
  userInfo: {},
  userRoles: [],
  chatToken: ''
}

export default state
